export const PRINT_SERVER = 'http://localhost:3001';
